/**
 * Expected national significant number lengths by ISO.
 * Derived from country-telephone-data format masks (dot count − dial length).
 * Do not hand-edit; regenerate if the data package is updated.
 *
 * For countries where mobile NSN length varies from the mask (or spans a
 * range), see {@link NSN_LENGTH_RANGE_BY_ISO}.
 */
export const NSN_LENGTH_BY_ISO = {
  AD: 6,
  AE: 8,
  AF: 9,
  AG: 7,
  AI: 7,
  AL: 9,
  AM: 8,
  AO: 9,
  AR: 10,
  AS: 7,
  AT: 10,
  AU: 9,
  AW: 7,
  AZ: 9,
  BA: 6,
  BB: 7,
  BD: 8,
  BE: 9,
  BF: 8,
  BG: 9,
  BH: 8,
  BI: 8,
  BJ: 8,
  BM: 7,
  BN: 7,
  BO: 8,
  BQ: 7,
  BR: 10,
  BS: 7,
  BT: 7,
  BW: 8,
  BY: 9,
  BZ: 7,
  CA: 10,
  CD: 9,
  CF: 8,
  CG: 9,
  CH: 9,
  CI: 8,
  CK: 5,
  CL: 9,
  CM: 8,
  CN: 10,
  CO: 10,
  CR: 8,
  CU: 8,
  CV: 7,
  CW: 7,
  CY: 8,
  CZ: 9,
  DE: 10,
  DJ: 8,
  DK: 8,
  DM: 7,
  DO: 10,
  DZ: 9,
  EC: 8,
  EE: 7,
  EG: 10,
  EH: 6,
  ER: 7,
  ES: 9,
  ET: 9,
  FI: 10,
  FJ: 7,
  FK: 5,
  FM: 7,
  FO: 6,
  FR: 9,
  GA: 7,
  GB: 10,
  GD: 7,
  GE: 9,
  GF: 9,
  GH: 9,
  GI: 8,
  GL: 6,
  GM: 7,
  GN: 8,
  GQ: 9,
  GR: 10,
  GT: 8,
  GU: 7,
  GW: 7,
  GY: 7,
  HK: 8,
  HN: 8,
  HR: 8,
  HT: 8,
  HU: 9,
  ID: 10,
  IE: 9,
  IL: 8,
  IN: 10,
  IO: 7,
  IQ: 10,
  IR: 10,
  IS: 7,
  IT: 9,
  JM: 7,
  JO: 9,
  JP: 9,
  KE: 9,
  KG: 9,
  KH: 8,
  KI: 5,
  KM: 7,
  KN: 7,
  KP: 6,
  KR: 9,
  KW: 8,
  KY: 7,
  KZ: 10,
  LA: 8,
  LB: 7,
  LC: 7,
  LI: 10,
  LK: 9,
  LR: 8,
  LS: 8,
  LT: 8,
  LU: 9,
  LV: 8,
  LY: 8,
  MA: 9,
  MC: 8,
  MD: 8,
  ME: 8,
  MG: 9,
  MH: 7,
  MK: 8,
  ML: 8,
  MM: 6,
  MN: 8,
  MO: 8,
  MP: 7,
  MQ: 9,
  MR: 8,
  MS: 7,
  MT: 8,
  MU: 7,
  MV: 7,
  MW: 9,
  MX: 10,
  MY: 10,
  MZ: 8,
  NA: 9,
  NC: 6,
  NE: 8,
  NF: 6,
  NG: 10,
  NI: 8,
  NL: 10,
  NO: 8,
  NP: 8,
  NR: 7,
  NU: 4,
  NZ: 10,
  OM: 8,
  PA: 7,
  PE: 9,
  PF: 6,
  PG: 8,
  PH: 10,
  PK: 10,
  PL: 9,
  PR: 10,
  PS: 9,
  PT: 9,
  PW: 7,
  PY: 9,
  QA: 8,
  RE: 9,
  RO: 9,
  RS: 9,
  RU: 10,
  RW: 9,
  SA: 9,
  SB: 5,
  SC: 7,
  SD: 9,
  SE: 9,
  SG: 8,
  SI: 8,
  SK: 9,
  SL: 8,
  SM: 10,
  SN: 9,
  SO: 7,
  SR: 6,
  SS: 9,
  ST: 7,
  SV: 8,
  SX: 7,
  SY: 9,
  SZ: 8,
  TC: 7,
  TD: 8,
  TG: 8,
  TH: 8,
  TJ: 9,
  TK: 4,
  TL: 7,
  TM: 8,
  TN: 8,
  TO: 5,
  TR: 10,
  TT: 7,
  TV: 5,
  TW: 8,
  TZ: 9,
  UA: 9,
  UG: 9,
  US: 10,
  UY: 8,
  UZ: 9,
  VA: 10,
  VC: 7,
  VE: 10,
  VG: 7,
  VI: 7,
  VN: 9,
  VU: 5,
  WF: 6,
  WS: 6,
  YE: 7,
  ZA: 9,
  ZM: 9,
  ZW: 7,
};

/**
 * Min/max national significant number lengths for countries where a single
 * mask length rejects valid mobile numbers. Used by assembleE164.
 */
export const NSN_LENGTH_RANGE_BY_ISO = {
  ID: { min: 9, max: 12 },
  // Mobiles are 010-XXXX-XXXX (10 digits after trunk 0); landlines 8-10.
  KR: { min: 8, max: 10 },
  MX: { min: 10, max: 10 },
  NG: { min: 10, max: 10 },
  PH: { min: 10, max: 10 },
  SA: { min: 9, max: 9 },
};
